import { __awaiter } from "tslib";
import { getConfig } from '@local/app-config';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getCombinedToken } from '../../store/sessionStorageHelpers/accessTokenHelper/accessTokenHelper';
const identityBaseQuery = (args, WebApi, extraOptions) => __awaiter(void 0, void 0, void 0, function* () {
    const identityBaseUrl = getConfig().identity_url;
    const rawBaseQuery = fetchBaseQuery({
        baseUrl: identityBaseUrl,
    });
    const result = yield rawBaseQuery(args, WebApi, extraOptions);
    if (result.error) {
        getCombinedToken();
    }
    return result;
});
export const IdentityApiClient = createApi({
    reducerPath: 'identityAPI',
    baseQuery: identityBaseQuery,
    endpoints: () => ({}),
});
//# sourceMappingURL=IdentityApiClient.js.map